import { entries, reduce, replace } from 'lodash';
import { z } from 'zod';

import { trimTrailingSlash } from '@/utils/urls';

function createEnv() {
  const envSchema = z.object({
    BASE_URL: z.string().optional(),
    FIREFLY_API_URL: z.string()
      .url()
      .transform(trimTrailingSlash),
    FIREFLY_ADMIN_API_URL: z.string()
      .url()
      .transform(trimTrailingSlash),
    BUGSNAG_RELEASE_STAGE: z.enum(['Production', 'QA', 'Development']).optional(),
    BUGSNAG_API_KEY: z.string().optional(),
    APP_VERSION: z.string().optional()
  });

  const envVars = reduce(
    entries(import.meta.env),
    (final, current) => {
      const [key, value] = current;

      if (key.startsWith('VITE_')) {
        final[replace(key, 'VITE_', '')] = value;
      }
      return final;
    },
    {} as unknown as Record<string, string>
  );

  const parsedEnv = envSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided:
      The following keys are missing or invalid:
      ${entries(parsedEnv.error.flatten().fieldErrors).map(([key, value]) => `${key}: ${value}`).join('\n')}
      `
    );
  }

  return parsedEnv.data;
}

export const env = createEnv();
